<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-hot-air-ballon`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 19c0-9.9-8-17-19-17S5 9.1 5 19c0 8.5 8.4 15.3 11 17.9V44c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7.1c2.6-2.6 11-9.4 11-17.9zM29.283 34C31.483 29.7 34 24.8 34 19c0-4.5-1.528-9.859-4-12.714 5.1 2.3 9 7.414 9 12.714 0 6-6.117 11.4-9.717 15zM23.2 34c-1.6-3-5.2-8.9-5.2-15 0-7.5 3.7-13 6-13s6 5.5 6 13c0 6.1-3.6 12-5.2 15h-1.6zM9 19c0-5.3 3.712-10.899 9-12.714C15.573 9.425 14 14.5 14 19c0 5.8 2.598 10.7 4.798 15C15.198 30.4 9 25 9 19zm19 23h-8v-4h8v4z"/></svg>
</template>
<script>

export default {
  name: 'IconHotAirBallon',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
